export default __webpack_public_path__ + "alberta-nexttermin.21455e814716bb174dcb.svg";